module.exports = __webpack_public_path__ + "img/fi-rr-password.4ed5ab17.svg";